<script lang="ts">
  import Form from "../components/Form.svelte";
  import RadioGroup from "../components/RadioGroup.svelte";
  import SharepointFileInput from "../components/SharepointFileInput.svelte";
  import Copy from "~icons/ph/copy";
  import { domId } from "../lib/dom";
  import revert from "../stores/revert";
  import { fade } from "svelte/transition";
  import { scrollIntoView } from "../lib/dom";

  let {
    action,
    forwardingEmail,
    createUploadSessionUrl,
    uploadAttachmentExtensions,
    errors
  }: {
    action: string;
    forwardingEmail: string;
    createUploadSessionUrl: string;
    uploadAttachmentExtensions: string[];
    errors: { [key: string]: string } | null;
  } = $props()

  const options: [string, string][] = [
    ["Yes, I received an email", "email"],
    ["Yes, I received a letter", "letter"],
    ["No, I don't have it", "no"]
  ]
  const closeDialogId = domId("close-dialog");
  let selectedOption = $state("email");
  let copied = revert(false, 3_000)

  async function copyMessage() {
    try {
      await navigator.clipboard.writeText(forwardingEmail);
      $copied = true;
    } catch (error) {
      console.error(error.message);
    }
  }
</script>

<Form method="patch" {action} class="ui-rhythm">
  <h2 class="ui-title">Data breach notification</h2>

  <p>If available, please upload a copy of the data breach notification from Capita or from your pension provider.</p>

  <fieldset class="ui-fieldset">
    <legend>Do you have a copy of the data breach notification?</legend>
    <RadioGroup
      name="has_notification"
      options={options}
      bind:group={selectedOption}
      required
    />
  </fieldset>

  <div class="ui-fieldset mt-6" class:hidden={selectedOption !== "email"}>
    <div>Please forward the notification email you received to this email address:</div>
    <div class="flex items-stretch join">
      <output class="input bg-neutral-50 overflow-hidden content-center input-disabled cursor-auto text-nowrap text-ellipsis join-item">
        {forwardingEmail}
      </output>
      <button type="button" onclick={copyMessage} class="btn min-w-20 join-item">
        {#if $copied}
          <span class="absolute text-xs" out:fade={{duration: 200}}>Copied</span>
        {:else}
          <span class="absolute" in:fade={{duration: 200}}><Copy class="text-xl" /></span>
        {/if}
      </button>
    </div>
    <div class="text-sm my-2 px-1 text-gray-600 leading-tight">Do not send any other correspondence to this address.</div>
    {#if errors?.email_not_received}<div class="ui-error" {@attach scrollIntoView({ behavior: "smooth", block: "center" })}>{errors.email_not_received}</div>{/if}
  </div>

  <fieldset class="ui-fieldset mt-6" disabled={selectedOption !== "letter"}>
    <legend>Please scan or take photo(s) of the letter you received and add them below.</legend>
    <SharepointFileInput
      name="data_breach_notification"
      accept={uploadAttachmentExtensions}
      {createUploadSessionUrl}
      required
    />
    {#if errors?.document_missing}<div class="ui-error">{errors.document_missing}</div>{/if}
  </fieldset>

  {#if errors?.general}<div class="ui-error">{errors.general}</div>{/if}

  <div class="floating-footer">
    <button class="btn btn-ghost" form={closeDialogId}>Cancel</button>
    <button class="btn btn-primary" type="submit" data-viewer-mode>{#if selectedOption == "letter"}Send{:else}Done{/if}</button>
  </div>
</Form>

<form method="dialog" id={closeDialogId}></form>

<style>
  fieldset[disabled] {
    @apply hidden;
  }
</style>
